import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import styles from './index.module.scss';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoTab, { EcoTabItemProps } from 'eco-design/elements/eco-tab';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoImg from 'eco-design/base/eco-img';
import { useState } from 'react';
import EFRefrigerator from 'elem/ui-assets/icons/appliances/EFRefrigerator';
import EFTV from 'elem/ui-assets/icons/appliances/EFTV';
import EFOven from 'elem/ui-assets/icons/appliances/EFOven';
import EFMicrowave from 'elem/ui-assets/icons/appliances/EFMicrowave';
import { useGlobal } from '@/utils/useGlobal';
import { useMediaDevice } from '@elem/compPage/Oasis/hooks';
import EfInfoSection from '@elem/ui/ef-info-section';
import EFLight from 'elem/ui-assets/icons/appliances/EFLight';
import EFPhone from 'elem/ui-assets/icons/appliances/EFPhone';
import Audio from 'elem/ui-assets/icons/appliances/Audio';
import InductionCooker from 'elem/ui-assets/icons/appliances/InductionCooker';
import EFCoffeeMaker from 'elem/ui-assets/icons/appliances/EFCoffeeMaker';
import EFFan from 'elem/ui-assets/icons/appliances/EFFan';
import Kettle from 'elem/ui-assets/icons/appliances/Kettle';
import ElectricBlanket from 'elem/ui-assets/icons/appliances/ElectricBlanket';
import Drone from 'elem/ui-assets/icons/appliances/Drone';
import EFLaptop from 'elem/ui-assets/icons/appliances/EFLaptop';
import Camera from 'elem/ui-assets/icons/appliances/Camera';
import ElectricHammer from 'elem/ui-assets/icons/appliances/ElectricHammer';

interface IconType {
    icon: JSX.Element;
    text: string;
    num: string;
    unit: string;
    prefix?: string;
}

interface ItemType {
    icons: IconType[];
    img: [string, string]; // [pc, h5]
    desc: string;
}

const JG: React.FC = () => {
    const { t } = useLang('delta3series');
    const { isH5 } = useMediaDevice();
    const items: ItemType[] = [
        {
            desc: t('G_item1_desc'),
            icons: [
                {
                    icon: <EFRefrigerator />,
                    text: t('G_item1_text1'),
                    num: t('G_item1_num1'),
                    unit: t('G_item1_unit1'),
                },
                {
                    icon: <EFTV />,
                    text: t('G_item1_text2'),
                    num: t('G_item1_num2'),
                    unit: t('G_item1_unit2'),
                },
                {
                    icon: <EFOven />,
                    text: t('G_item1_text3'),
                    num: t('G_item1_num3'),
                    unit: t('G_item1_unit3'),
                },
                {
                    icon: <EFMicrowave />,
                    text: t('G_item1_text4'),
                    num: t('G_item1_num4'),
                    unit: t('G_item1_unit4'),
                },
            ],
            img: [
                'https://websiteoss.ecoflow.com/upload/image/1740966890801/Group%20161269132%20(1).jpg',
                'https://websiteoss.ecoflow.com/upload/image/1740967014033/Mask%20group.jpg',
            ],
        },
        {
            desc: t('G_item2_desc'),
            icons: [
                {
                    icon: <EFLight />,
                    text: t('G_item2_text1'),
                    num: t('G_item2_num1'),
                    unit: t('G_item2_unit1'),
                },
                {
                    icon: <EFPhone />,
                    text: t('G_item2_text2'),
                    num: t('G_item2_num2'),
                    unit: t('G_item2_unit2'),
                },
                {
                    icon: <InductionCooker />,
                    text: t('G_item2_text3'),
                    num: t('G_item2_num3'),
                    unit: t('G_item2_unit3'),
                },
                {
                    icon: <Audio />,
                    text: t('G_item2_text4'),
                    num: t('G_item2_num4'),
                    unit: t('G_item2_unit4'),
                },
            ],
            img: [
                'https://websiteoss.ecoflow.com/upload/image/1740966890957/Group%201612706648%20(1).jpg',
                'https://websiteoss.ecoflow.com/upload/image/1740967013440/Mask%20group%20(1).jpg',
            ],
        },
        {
            desc: t('G_item3_desc'),
            icons: [
                {
                    icon: <ElectricBlanket />,
                    text: t('G_item3_text1'),
                    num: t('G_item3_num1'),
                    unit: t('G_item3_unit1'),
                },
                {
                    icon: <EFFan />,
                    text: t('G_item3_text2'),
                    num: t('G_item3_num2'),
                    unit: t('G_item3_unit2'),
                },
                {
                    icon: <Kettle />,
                    text: t('G_item3_text3'),
                    num: t('G_item3_num3'),
                    unit: t('G_item3_unit3'),
                },
                {
                    icon: <EFCoffeeMaker />,
                    text: t('G_item3_text4'),
                    num: t('G_item3_num4'),
                    unit: t('G_item3_unit4'),
                },
            ],
            img: [
                'https://websiteoss.ecoflow.com/upload/image/1740966891395/Group%201612706649%20(1).jpg',
                'https://websiteoss.ecoflow.com/upload/image/1740967013831/Mask%20group%20(2).jpg',
            ],
        },
        {
            desc: t('G_item4_desc'),
            icons: [
                {
                    icon: <ElectricHammer />,
                    text: t('G_item4_text1'),
                    num: t('G_item4_num1'),
                    unit: t('G_item4_unit1'),
                },
                {
                    icon: <Drone />,
                    text: t('G_item4_text2'),
                    num: t('G_item4_num2'),
                    unit: t('G_item4_unit2'),
                    prefix: t('G_item4_prefix2'),
                },
                {
                    icon: <Camera />,
                    text: t('G_item4_text3'),
                    num: t('G_item4_num3'),
                    unit: t('G_item4_unit3'),
                    prefix: t('G_item4_prefix3'),
                },
                {
                    icon: <EFLaptop />,
                    text: t('G_item4_text4'),
                    num: t('G_item4_num4'),
                    unit: t('G_item4_unit4'),
                    prefix: t('G_item4_prefix4'),
                },
            ],
            img: [
                'https://websiteoss.ecoflow.com/upload/image/1740966891217/Group%201612706650%20(1).jpg',
                'https://websiteoss.ecoflow.com/upload/image/1740967013637/Mask%20group%20(3).jpg',
            ],
        },
    ];
    const [active, setActive] = useState(items[0]);

    const tabs: EcoTabItemProps[] = [
        {
            tabValue: '0',
            tabLabel: t('G_tab1'),
        },
        {
            tabValue: '1',
            tabLabel: t('G_tab2'),
        },
        {
            tabValue: '2',
            tabLabel: t('G_tab3'),
        },
        {
            tabValue: '3',
            tabLabel: t('G_tab4'),
        },
    ];
    return (
        <div className={styles.comp} id="d3-G">
            <EfInfoSection title={t('G_title')} desc={t('G_desc')} />
            <EcoSpaceSmall />
            {!isH5 && (
                <div className="box">
                    <div className="inner">
                        <div className="img-box">
                            <EcoImg pc={active.img[0]} pad={active.img[0]} h5={active.img[1]} />
                            {/* <p className="desc">{active.desc}</p> */}
                        </div>
                        <ul className="icons">
                            {active.icons.map((icon: IconType, k: number) => (
                                <li className="icon" key={k}>
                                    <div className="icon-svg">{icon.icon}</div>
                                    <p className="icon-text">{icon.text}</p>
                                    <div className="icon-suffix">
                                        <span className="icon-unit">{icon.prefix}</span>
                                        <span className="icon-num">{icon.num}</span>
                                        <span className="icon-unit">{icon.unit}</span>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            )}

            {isH5 && (
                <div className="box">
                    {items.map((item) => {
                        return (
                            <div className="inner">
                                <div className="img-box">
                                    <EcoImg pc={item.img[0]} pad={item.img[0]} h5={item.img[1]} />
                                    <p className="desc">{item.desc}</p>
                                </div>
                                <ul className="icons">
                                    {item.icons.map((icon: IconType, k: number) => (
                                        <li className="icon" key={k}>
                                            <div className="icon-svg">{icon.icon}</div>
                                            <p className="icon-text">{icon.text}</p>
                                            <div className="icon-suffix">
                                                <span className="icon-num">{icon.num}</span>
                                                <span className="icon-unit">{icon.unit}</span>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        );
                    })}
                </div>
            )}

            {!isH5 && <EcoTab items={tabs} onChange={(_: EcoTabItemProps, k: number) => setActive(items[k])} />}
            {/* <EcoSpace /> */}
        </div>
    );
};

export default JG;
